import { render, staticRenderFns } from "./LostAccess.vue?vue&type=template&id=694464d2"
import script from "./LostAccess.vue?vue&type=script&lang=js"
export * from "./LostAccess.vue?vue&type=script&lang=js"
import style0 from "./LostAccess.vue?vue&type=style&index=0&id=694464d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports